'use client';

import H2 from '@/components/typography/h2';
import Label from '@/components/typography/label';
import { Button } from '@/components/ui/button';
import { ServiceType } from '@/payload-types';
import { Circle, Dot } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@/components/ui/accordion';

interface FilterProps {
    services: ServiceType[];
    selectedServices: ServiceType[];
    setSelectedServices: React.Dispatch<React.SetStateAction<ServiceType[]>>;
}

export default function Filter({
    services,
    selectedServices,
    setSelectedServices,
}: FilterProps) {
    const { t } = useTranslation();

    const toggleSelectService = (item: ServiceType) => {
        setSelectedServices((prev) => {
            const exists = prev.some((s) => s.id === item.id);
            return exists
                ? prev.filter((s) => s.id !== item.id)
                : [...prev, item];
        });
    };

    const isServiceSelected = (id: string) =>
        selectedServices.some((s) => s.id === id);

    return (
        <div className="flex flex-col items-center justify-center md:mt-[64px] lg:mb-[4rem] lg:gap-5">
            <div className="hidden w-full justify-center md:flex">
                <div className="-mt-[4rem] flex items-center gap-10 px-4">
                    <H2 className="text-[20px]! normal-case">
                        {t('filter.services')}
                    </H2>
                    <div className="flex flex-wrap gap-4">
                        {services.map((item) => (
                            <Button
                                key={item.id}
                                onClick={() => toggleSelectService(item)}
                                variant="filter"
                            >
                                {isServiceSelected(item.id) ? (
                                    <Dot
                                        className="scale-[5]"
                                        size={12}
                                        strokeWidth={2}
                                    />
                                ) : (
                                    <Circle size={2} />
                                )}
                                <Label>{item.naam}</Label>
                            </Button>
                        ))}
                    </div>
                </div>
            </div>
            <div className="w-full md:hidden">
                <div className="border-primary w-full border-t px-5 py-8 sm:border-y">
                    <Accordion type="single" collapsible>
                        <AccordionItem value="item-1">
                            <AccordionTrigger className="abc py-0 text-[20px]">
                                {t('filter.services')}
                            </AccordionTrigger>
                            <AccordionContent>
                                <div className="mt-4 flex flex-wrap gap-2">
                                    {services.map((item) => (
                                        <Button
                                            key={item.id}
                                            onClick={() =>
                                                toggleSelectService(item)
                                            }
                                            variant="filter"
                                        >
                                            {isServiceSelected(item.id) ? (
                                                <Dot
                                                    size={8}
                                                    strokeWidth={20}
                                                />
                                            ) : (
                                                <Circle size={8} />
                                            )}
                                            <Label>{item.naam}</Label>
                                        </Button>
                                    ))}
                                </div>
                            </AccordionContent>
                        </AccordionItem>
                    </Accordion>
                </div>
            </div>
        </div>
    );
}
